import s from "./ghl-ui.es1506.js";
import f from "./ghl-ui.es1466.js";
function i(a) {
  f(1, arguments);
  var e = 1, t = s(a), r = t.getUTCDay(), o = (r < e ? 7 : 0) + r - e;
  return t.setUTCDate(t.getUTCDate() - o), t.setUTCHours(0, 0, 0, 0), t;
}
export {
  i as default
};
